import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";

import MenuBarMenu from "./menu-bar-menu.jsx";
import ThemeMenu from "./theme-menu.jsx";
import { MenuSection } from "../menu/menu.jsx";

import menuBarStyles from "./menu-bar.css";
import styles from "./settings-menu.css";

import dropdownCaret from "./dropdown-caret.svg";
import settingsIcon from "./icon--settings.svg";

const SettingsMenu = ({
    canChangeTheme,
    isRtl,
    onRequestClose,
    onRequestOpen,
    settingsMenuOpen,
}) => (
    <div
        className={classNames(
            menuBarStyles.menuBarItem,
            menuBarStyles.hoverable,
            menuBarStyles.themeMenu,
            {
                [menuBarStyles.active]: settingsMenuOpen,
            }
        )}
        onMouseUp={onRequestOpen}
    >
        <img src={settingsIcon} />
        <span className={styles.dropdownLabel}>
            <FormattedMessage
                defaultMessage="Settings"
                description="Settings menu"
                id="gui.menuBar.settings"
            />
        </span>
        <img src={dropdownCaret} />
        <MenuBarMenu
            className={menuBarStyles.menuBarMenu}
            open={settingsMenuOpen}
            place={isRtl ? "left" : "right"}
            onRequestClose={onRequestClose}
        >
            <MenuSection>
                {canChangeTheme && (
                    <ThemeMenu onRequestCloseSettings={onRequestClose} />
                )}
            </MenuSection>
        </MenuBarMenu>
    </div>
);

SettingsMenu.propTypes = {
    canChangeTheme: PropTypes.bool,
    isRtl: PropTypes.bool,
    onRequestClose: PropTypes.func,
    onRequestOpen: PropTypes.func,
    settingsMenuOpen: PropTypes.bool,
};

export default SettingsMenu;
